// MUNYA OS · Input · sistema componentes ui/ v1
//
// Label · helper · error · adornos prefix/suffix · accesibilidad por defecto.
// Sirve para text/email/password/number/url/tel/date.

import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
  label?: string;
  helperText?: string;
  errorMessage?: string;
  prefix?: ReactNode;
  suffix?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, helperText, errorMessage, prefix, suffix, id, className = '', ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const helperId = `${inputId}-helper`;
  const errorId = `${inputId}-error`;
  const describedBy =
    [errorMessage ? errorId : null, helperText ? helperId : null].filter(Boolean).join(' ') ||
    undefined;

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label htmlFor={inputId} className="mn-label mb-0">
          {label}
        </label>
      )}
      {/* .mn-field = campo compuesto del sistema (#422): alto 40, radio 8, letra 13,
          borde arena → oliva en hover/foco y contorno alrededor del ENVOLTORIO, no
          del input desnudo. Antes iba a mano con `h-10 px-3`, que en esta app mide el
          doble (--spacing = 0.5rem): 80px de alto y 24px de padding. */}
      <div
        className={['mn-field', errorMessage ? 'border-[var(--color-munya-destructive)]' : ''].join(
          ' ',
        )}
      >
        {prefix && <span className="text-[var(--color-munya-coffee)]/60">{prefix}</span>}
        <input
          ref={ref}
          id={inputId}
          aria-invalid={errorMessage ? true : undefined}
          aria-describedby={describedBy}
          className="flex-1 min-w-0 bg-transparent placeholder:text-[var(--color-munya-coffee)]/40"
          {...rest}
        />
        {suffix && <span className="text-[var(--color-munya-coffee)]/60">{suffix}</span>}
      </div>
      {errorMessage ? (
        <p id={errorId} role="alert" className="text-xs text-[var(--color-munya-destructive)]">
          {errorMessage}
        </p>
      ) : helperText ? (
        <p id={helperId} className="text-xs opacity-60">
          {helperText}
        </p>
      ) : null}
    </div>
  );
});
